<template>
  <section class="kalkkilaskuri">
    <div class="wrapper">
      <Laskuri />
    </div>
    <div v-if="getKalkkilaskuriProducts" class="wrapper mt-5">
      <SelectedProductsGrid />
    </div>
    <div class="wrapper mt-3">
      <OtherProduct />
    </div>
  </section>
</template>

<script>
import Laskuri from "./components/Laskuri.vue";
import { mapGetters } from "vuex";
import SelectedProductsGrid from "./components/SelectedProductsGrid";
import OtherProduct from "./components/OtherProduct.vue";

export default {
  name: "Kalkkilaskuri",
  components: {
    Laskuri,
    SelectedProductsGrid,
    OtherProduct,
  },
  computed: {
    ...mapGetters(["getSeller", "getKalkkilaskuriProducts"]),
  },
};
</script>

<style lang="scss" scoped>
.kalkkilaskuri {
  padding-top: 2rem;
  padding-bottom: 2rem;
  color: var(--bs-light);
}
</style>
